import * as React from 'react';
import * as Yup from 'yup';

import { EntityActions, EntityType } from 'common/entity';
import { Formik, FormikActions, FormikProps } from 'formik';
import { mergeFields, processApiError } from 'common/utils/form';

import { MediaUpload } from 'common/components/form/MediaUpload';
import { toSlug } from 'common/utils/utils';
import { Member } from 'common/api/models/Member';
import { MemberApi } from 'common/api/resources/MemberApi';
import { FormInput } from 'common/components/form/FormInput';

interface UserDetailsFormProps {
  user: Member;
  entityActions: EntityActions;
}
class UserDetailsFormValues {
  firstName = '';
  lastName = '';
  email = '';
  imagePath = '';
}

export class UserDetailsForm extends React.Component<UserDetailsFormProps> {
  validationSchema = Yup.object().shape({
    firstName: Yup.string().required('Required'),
    lastName: Yup.string().required('Required'),
    email: Yup.string()
      .required('Required')
      .email(),
  });

  initialValues() {
    return mergeFields(new UserDetailsFormValues(), {
      ...this.props.user,
    });
  }

  handleSubmit = (values: UserDetailsFormValues, actions: FormikActions<UserDetailsFormValues>) => {
    MemberApi.updateMember(this.props.user.id!, values).then(
      res => {
        this.props.entityActions.refetch(EntityType.MEMBER, this.props.user.id!);
        actions.setSubmitting(false);
        actions.setStatus({ success: true });
      },
      err => {
        processApiError<UserDetailsFormProps, UserDetailsFormValues>(err, actions);
      }
    );
  };

  render() {
    return (
      <Formik
        initialValues={this.initialValues()}
        validationSchema={this.validationSchema}
        onSubmit={this.handleSubmit}
        render={(form: FormikProps<UserDetailsFormValues>) => (
          <form onSubmit={form.handleSubmit} style={{ textAlign: 'left' }}>
            <div className="row">
              <div className="col">
                <FormInput id="firstName" name="firstName" label="First Name" autoComplete="off" />
              </div>
              <div className="col">
                <FormInput id="lastName" name="lastName" label="Last name" autoComplete="off" />
              </div>
            </div>
            <div className="row">
              <div className="col">
                <FormInput id="email" name="email" label="Email" autoComplete="off" />
              </div>
            </div>
            <div className="row">
              <div className="col">
                <label>Profile Image</label>
                <MediaUpload
                  id="imagePath"
                  value={form.values.imagePath}
                  slug={toSlug(form.values.firstName + ' ' + form.values.lastName)}
                  onChange={form.setFieldValue}
                />
              </div>
            </div>
            <div className="row" style={{ marginTop: 10, textAlign: 'right' }}>
              <div className="col">
                <button className="btn btn-primary">Save</button>
              </div>
            </div>
            {form.status &&
              form.status.success && (
                <div className="alert alert-success" style={{ marginTop: 20 }}>
                  Your user information has been saved.
                </div>
              )}
            {form.status &&
              !form.status.success && (
                <div className="row" style={{ marginTop: 20 }}>
                  <div className="col">
                    <div className="alert alert-danger">{form.status}</div>
                  </div>
                </div>
              )}
          </form>
        )}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/UserSettings/UserDetailsForm.tsx